<template>
  <div class="money-checkbox">
    <input type="checkbox" :id="_uid" :checked="checked" @change="$emit('input', $event.target.checked)" />
    <label :for="_uid">
      <font-awesome-icon icon="money-bill-wave" v-bind:class="{ checked: checked }" />
    </label>
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    checked() {
      return this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.money-checkbox {
  position: relative;
  background: white;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 2px solid #ff9100;
  user-select: none;

  label {
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;

    & > svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #7cb342;
      opacity: 0.3;
      transition: all 0.25s;
    }
  }

  input[type="checkbox"] {
    position: absolute;
    visibility: hidden;
  }

  .checked {
    opacity: 1;
  }
}
</style>